/* eslint-disable no-param-reassign  */
import { createSlice } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';

const initialState = {
  lastQuestionId: 0,
  isCurrentQuestionValid: false,
  quizFinished: false,
  registrationModalOpen: false,
  quizValues: {
    currentHouse: null,
    currentHouseValue: 0,
    currentHouseMortgageBal: 0,

    hasSecondPerson: null,

    secondIncomeValue: 0,
    secondCarPaymentValue: 0,
    secondStudentPaymentValue: 0,
    secondCardPaymentValue: 0,
    secondOtherPaymentValue: 0,
    secondSavingsValue: 0,

    incomeValue: 75000,
    carPaymentValue: 250,
    studentPaymentValue: 75,
    cardPaymentValue: 50,
    otherPaymentValue: 0,
    savingsValue: 45000,

    dtiLevel: 0.3,
    interestRate: 0.05,
    monthsCushion: 2,
    mortgageTerm: 30,
    propertyTaxRate: 0.013,
  },
  manuallyChangedFields: {
    secondCarPaymentValue: false,
    secondStudentPaymentValue: false,
    secondCardPaymentValue: false,
    secondOtherPaymentValue: false,
    secondSavingsValue: false,

    carPaymentValue: false,
    studentPaymentValue: false,
    cardPaymentValue: false,
    otherPaymentValue: false,
    savingsValue: false,
  },
};

const quizSlice = createSlice({
  name: 'quizSlice',
  initialState,
  reducers: {
    submitCurrentStep(state, { payload }) {
      state.lastQuestionId = payload;
    },
    changeValue(state, { payload }) {
      const { field, value } = payload;
      const { quizValues } = state;
      quizValues[field] = value;
    },
    setCurrentQuestionValidity(state, { payload }) {
      state.isCurrentQuestionValid = payload;
    },
    setManuallyChangedFields(state, { payload }) {
      const { manuallyChangedFields } = state;
      const { field } = payload;
      manuallyChangedFields[field] = true;
    },
    discardQuiz() {
      return { ...initialState };
    },
    setFinishQuiz(state, { payload }) {
      state.quizFinished = payload;
    },
    setRegistrationModalOpen(state, { payload }) {
      state.registrationModalOpen = payload;
    },
  },
});

export const { actions } = quizSlice;

export default quizSlice.reducer;

export const useAppActions = () => {
  const dispatch = useDispatch();

  const submitCurrentStep = currentQuestionId => {
    dispatch(actions.submitCurrentStep(currentQuestionId));
  };

  const changeValue = attrs => {
    dispatch(actions.changeValue(attrs));
  };

  const setFinishQuiz = value => {
    dispatch(actions.setFinishQuiz(value));
  };

  const setRegistrationModalOpen = value => {
    dispatch(actions.setRegistrationModalOpen(value));
  };

  const setCurrentQuestionValidity = valid => {
    dispatch(actions.setCurrentQuestionValidity(valid));
  };

  const setManuallyChangedField = attrs => {
    dispatch(actions.setManuallyChangedFields(attrs));
  };

  const discardQuiz = () => {
    dispatch(actions.discardQuiz());
  };

  return {
    submitCurrentStep,
    discardQuiz,
    setFinishQuiz,
    setManuallyChangedField,
    setRegistrationModalOpen,
    setCurrentQuestionValidity,
    changeValue,
  };
};
/* eslint-enable no-param-reassign */



// WEBPACK FOOTER //
// ./src/reducers/slices/quizSlice.js